export default __webpack_public_path__ + "static/media/selecta_cube@2x.52a182a6.jpg";